/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconInfo extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "InfoIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' x="0px" y="0px" viewBox="0 0 64 64" ><g><path fill="#231F20"  d="M31.812,46.003c-8.814,0-15.984-7.17-15.984-15.983c0-8.814,7.17-15.984,15.984-15.984 c8.813,0,15.983,7.17,15.983,15.984C47.796,38.833,40.626,46.003,31.812,46.003z M31.812,16.235 c-7.601,0-13.785,6.185-13.785,13.785s6.185,13.784,13.785,13.784s13.784-6.184,13.784-13.784S39.413,16.235,31.812,16.235z"></path><path fill="#231F20"  d="M30.224,22.622c0-0.828,0.69-1.357,1.587-1.357c0.897,0,1.587,0.529,1.587,1.357v0.138 c0,0.828-0.689,1.38-1.587,1.38c-0.896,0-1.587-0.552-1.587-1.38V22.622z M30.431,27.152c0-0.781,0.599-1.402,1.38-1.402 c0.782,0,1.403,0.621,1.403,1.402v9.612c0,0.782-0.621,1.38-1.403,1.38c-0.759,0-1.38-0.598-1.38-1.38V27.152z"></path></g></svg>
    `;
}
